import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = heroSlides[current];

  return (
    <section className="relative h-[520px] md:h-[620px] w-full overflow-hidden">
      {heroSlides.map((s, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-700 ${idx === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
            {slide.title}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto">
            {slide.subtitle}
          </p>
          <button
            onClick={() => {
              window.scrollTo({ top: window.innerHeight * 0.8, behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-lg"></i>
            {slide.cta}
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current ? 'bg-primary-500 w-6' : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`切换到第 ${idx + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}